module.exports = __webpack_public_path__ + "img/ruoyi10.de7dac71.png";